var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23111(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.716,
    height: 31.726,
    viewBox: "0 0 31.716 31.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23111",
    "data-name": "Path 23111",
    d: "M100.594,80.406,84.5,96.5a.993.993,0,0,1-.507.27L75.834,98.4a.991.991,0,0,1-1.163-1.171L76.3,89.07a.986.986,0,0,1,.271-.506L92.667,72.472Zm4.85-4.909-3.5,3.5L94.063,71.07l3.5-3.5a2.977,2.977,0,0,1,4.209,0L105.5,71.29a2.921,2.921,0,0,1-.056,4.208",
    transform: "translate(-74.65 -66.694)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23111);
export default __webpack_public_path__ + "static/media/Path 23111.d042b217dfc89545035d82bdcbb3765c.svg";
export { ForwardRef as ReactComponent };